import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconBaseballCapStyle0 = cosmosIconCss;

const CosmosIconBaseballCap$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconBaseballCap extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'a1aea2cd1d66cc21bccbf3a2588c23cff855e565', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '6acf1f4b8af860f1bab20750cce9b7e885b2b74a', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '24784f252d8df58edfaed78beee35de9f2798f10', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M15 12.024V11a5.822 5.822 0 0 0-6-6 5.828 5.828 0 0 0-6 6v1.6C3 13.93 5.68 15 9 15h3.973C18.31 15 20 14.639 20 13.5c0-.98-1.259-1.382-5-1.476Zm-10.5.427V11A4.353 4.353 0 0 1 9 6.5a4.3 4.3 0 0 1 4.5 4.5v1.45c-.371.389-1.978 1.05-4.5 1.05-2.522 0-4.129-.661-4.5-1.05Z", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconBaseballCapStyle0; }
}, [1, "cosmos-icon-baseball-cap", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-baseball-cap"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-baseball-cap":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconBaseballCap$1);
            }
            break;
    } });
}

const CosmosIconBaseballCap = CosmosIconBaseballCap$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconBaseballCap, defineCustomElement };
